import { FwdRollMutableRowModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollMutableRowModel";
import { FwdRollPortfolioModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollPortfolioModel";
import {
  BigNumber,
  FwdRollCurrencyNetPricingImpl,
  FwdRollRowType,
  Tenor,
} from "shared/cubiq-model-multi-asset";

export class FwdRollCurrencyModel
  extends FwdRollCurrencyNetPricingImpl
  implements FwdRollMutableRowModel
{
  ptsPrecision: number;

  ptsMultiplier: BigNumber;

  minPrecision: number;

  /* For Change detection */
  primedMarketForwardPts: BigNumber;
  primedClientForwardPts: BigNumber;
  primedFwdMarkup: BigNumber;

  public isMarketPtsChanged: boolean;
  public isClientPtsChanged: boolean;
  public isFwdMarkupChanged: boolean;
  public lockedForUserPricing: boolean;
  public isEditorDisabled: boolean = false;

  /** Should strikethrough of missing points be disabled? */
  public disableMissingPoints: boolean = false;

  constructor(private portfolioModel: FwdRollPortfolioModel) {
    super();
  }

  public get rowType() {
    return FwdRollRowType.CURRENCY;
  }

  public get isChanged(): boolean {
    return this.isMarketPtsChanged || this.isClientPtsChanged || this.isFwdMarkupChanged;
  }

  /**
   * Can this row be edited?
   */
  public get isEditable(): boolean {
    const canEdit =
      !this.portfolioModel.disabled && !this.spotAggregateFg && this.settleTenor !== Tenor.SPOT; // &&
    // see FXBFXOM-5416 for hidden functionality scheduling
    // !this.hidden;
    return canEdit;
  }

  /**
   * Does this model support blotter selection? Should be fault for all currency rows,
   * spot aggregate rows or Spot tenor rows
   */
  public get supportsSelection(): boolean {
    return false;
  }

  public get marketForwardPtsScaled(): BigNumber {
    return this.marketForwardPts?.div(this.ptsMultiplier);
  }

  public get clientForwardPtsScaled(): BigNumber {
    return this.clientForwardPts?.div(this.ptsMultiplier);
  }

  public get forwardMarkupScaled(): BigNumber {
    return this.fwdMarkup?.div(this.ptsMultiplier);
  }

  public get missingFwdPoints(): boolean {
    return this.missingPoints === true && !this.disableMissingPoints;
  }

  public updateMarketForwardPts(value: BigNumber): boolean {
    return this.portfolioModel.updateMarketForwardPts(this, value);
  }

  updateClientForwardPts(value: BigNumber): boolean {
    return this.portfolioModel.updateClientForwardPts(this, value);
  }

  updateForwardMarkup(value: BigNumber): boolean {
    return this.portfolioModel.updateForwardMarkup(this, value);
  }

  recalcCounterAmount(): string {
    if (this.nonBaseCcy === "USD") {
      this.netUsdEquivAmt = this.netFixedAmt.times(this.marketForwardRate);
    } else {
      this.netUsdEquivAmt = this.netFixedAmt.dividedBy(this.marketForwardRate);
    }

    return "netUsdEquivAmt";
  }

  public get intent() {
    return this.netIntent;
  }
}
